<template>
  <a-modal :title="modal.title" v-model="modal.visible" :width="700">
    <div>
      <div class="flex justify-between mb-4">
        <a-form layout="inline" :form="modal.form" :colon="false">
          <a-form-item label="供应商名称">
            <a-input v-decorator="['supplierCompanyName']" placeholder="请输入供应商名称"></a-input>
          </a-form-item>
        </a-form>
        <div>
          <a-button class="mr-3" type="default" @click="resetAndQuery">重置搜索</a-button>
          <a-button class="" type="primary" @click="doQuery()">立即搜索</a-button>
        </div>
      </div>
      <a-table
        class="origin-style ant-info-table"
        :rowKey="(record, index)=>{return index}"
        :columns="tableColumns"
        :dataSource="dataSource"
        :rowSelection="getRowSelection('radio')"
        bordered
        @change="handleTableChange$qv"
        :customRow="dbClickSelect()"
        size="middle"
        :pagination="{
          current: pageNumber,
          pageSize: pageSize,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      ></a-table>
    </div>
    <template slot="footer">
      <a-button @click="handleOk" type="primary">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '供应商名称',
        width: '45%',
        align: 'center',
        dataIndex: 'supplierCompanyName',
      },
      {
        title: '已代理产品',
        width: '45%',
        align: 'center',
        dataIndex: 'productName',
      },
    ]
    return {
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
      selectedRows: [],
      selectedRowKeys: [],
      rowKey: 'supplierCompanyId',
      // 添加送签产品modal
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '选择供应商',
        data: {},
      },
    }
  },
  methods: {
    start(row) {
      this.init(row)
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          this.modal.visible = false
        })
      })
    },
    init(row) {
      this.reset$t()
      this.modal.data = { ...row }
      this.doQuery()
      this.modal.visible = true
    },
    getRowSelection(type) {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        columnTitle: '选择',
        columnWidth: 80,
        type: type,
      }
    },
    async handleOk() {
      const rowData = this.selectedRows[0]
      if (!rowData) {
        return this.$message.error('请选择供应商！')
      }
      await this.$axios.post('/product-web-api/admin/productTransefer/setSupplier', {
        data: {
          productId: this.modal.data.productId,
          supplierCompanyId: rowData.supplierCompanyId,
          supplierCompanyName: rowData.supplierCompanyName,
        },
      })
      this.$message.success('操作成功！')
      this.$emit('end', 'ok', {})
    },
    dbClickSelect({ type = 'radio' } = {}) {
      return (row, index) => {
        return {
          on: {
            dblclick: async () => {
              const { rowKey } = this
              if (row[rowKey]) {
                if (type === 'radio') {
                  this.selectedRowKeys = [row[rowKey]]
                  this.selectedRows = [row]
                }
                if (type === 'checkbox') {
                  if (this.selectedRowKeys) {
                    const selectedRowKeys = [...this.selectedRowKeys]

                    const rowKeyIndex = selectedRowKeys.findIndex(item => item === row[rowKey])

                    if (rowKeyIndex === -1) {
                      selectedRowKeys.push(row[rowKey])
                    } else {
                      selectedRowKeys.splice(rowKeyIndex, 1)
                    }
                    this.selectedRowKeys = selectedRowKeys
                  }

                  if (this.selectedRows) {
                    const selectedRows = [...this.selectedRows]
                    const rowIndex = selectedRows.findIndex(item => item[rowKey] === row[rowKey])
                    if (rowIndex === -1) {
                      selectedRows.push(row)
                    } else {
                      selectedRows.splice(rowIndex, 1)
                    }
                    this.selectedRows = selectedRows
                  }
                }
              } else {
                console.error('correct rowKey required')
              }
            },
          },
        }
      }
    },
    async doQuery() {
      this.tableLoading = true
      try {
        const res = await this.$axios.post('/product-web-api/admin/productTransefer/querySupplierList', {
          data: {
            supplierCompanyName: this.modal.form.getFieldValue('supplierCompanyName'),
          },
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        })
        const { total, content } = res.data
        this.countTotal = Number(total)
        this.dataSource = content
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    resetAndQuery() {
      this.modal.form.resetFields()
      this.doQuery()
    },
  },
}
</script>

<style></style>
